import { AppRoutes } from "./router.jsx";

export function App() {
  return <AppRoutes />;
}
